import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { firebaseConfig } from "./firebase.config";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";

export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseDB = getFirestore(firebaseApp);

if (process.env.REACT_APP_USE_FIREBASE_EMULATOR === "true") {
  console.log(
    "Starting in development environment. Connecting to emulators...",
  );
  const auth = getAuth(firebaseApp);

  // Connect to emulators
  connectFirestoreEmulator(firebaseDB, "localhost", 8080);
  connectAuthEmulator(auth, "http://localhost:9099");
}

const analytics = getAnalytics(firebaseApp);
analytics.app.automaticDataCollectionEnabled = true;
